export enum EAC_ENTITLEMENT_ERROR_TYPE {
  REQUESTED_QUANTITY_EXCEEDS_AVAILABLE = 'REQUESTED_QUANTITY_EXCEEDS_AVAILABLE',
}

export const getEacCheckoutErrorStringId = (errorType?: string): string | undefined => {
  switch (errorType) {
    case EAC_ENTITLEMENT_ERROR_TYPE.REQUESTED_QUANTITY_EXCEEDS_AVAILABLE:
      return 'checkout_step_error_exceeds_inventory';
    default:
      return undefined;
  }
};
